import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { followTalent, unfollowTalent, isFollowingTalent } from '../../services/talentService';
import Button from './Button';
import Icon from '../AppIcon';

const FollowButton = ({ talentId, onFollowChange }) => {
  const { user } = useAuth();
  const [isFollowing, setIsFollowing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    checkFollowStatus();
  }, [talentId, user]);

  const checkFollowStatus = async () => {
    if (!user || !talentId) {
      setCheckingStatus(false);
      return;
    }

    try {
      setCheckingStatus(true);
      const { data, error } = await isFollowingTalent(talentId);
      if (!error) {
        setIsFollowing(data);
      }
    } catch (err) {
      console.error('Error checking follow status:', err);
    } finally {
      setCheckingStatus(false);
    }
  };

  const handleFollowToggle = async () => {
    if (!user) {
      alert('Please sign in to follow talent');
      return;
    }

    try {
      setLoading(true);
      
      if (isFollowing) {
        const { error } = await unfollowTalent(talentId);
        if (error) throw error;
        setIsFollowing(false);
      } else {
        const { error } = await followTalent(talentId);
        if (error) throw error;
        setIsFollowing(true);
      }

      if (onFollowChange) {
        onFollowChange(!isFollowing);
      }
    } catch (err) {
      console.error('Error toggling follow:', err);
      alert(`Failed to ${isFollowing ? 'unfollow' : 'follow'} talent: ${err?.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (!user || checkingStatus) {
    return null;
  }

  return (
    <Button
      onClick={handleFollowToggle}
      disabled={loading}
      className={`${
        isFollowing
          ? 'bg-gray-200 text-gray-700 hover:bg-gray-300 border-gray-300' :'bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:from-purple-700 hover:to-indigo-700 border-0'
      } rounded-lg px-6 py-2 transition-all duration-200 shadow-md`}
    >
      {loading ? (
        <span className="flex items-center space-x-2">
          <Icon name="Loader" size={16} className="animate-spin" />
          <span>{isFollowing ? 'Unfollowing...' : 'Following...'}</span>
        </span>
      ) : (
        <span className="flex items-center space-x-2">
          <Icon name={isFollowing ? 'UserCheck' : 'UserPlus'} size={16} />
          <span>{isFollowing ? 'Following' : 'Follow'}</span>
        </span>
      )}
    </Button>
  );
};

export default FollowButton;